import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoPatientTemplateListTemplate } from 'themes/application/niko-patient/pages';
import { NikoPatientTemplateListViewStore } from '../stores';

@setCurrentView((rootStore, patient) => new NikoPatientTemplateListViewStore(rootStore, patient), 'nikoPatientTemplateListViewStore')
@observer
class NikoPatientTemplateList extends React.Component {
    render() {
        return <NikoPatientTemplateListTemplate {...this.props} />
    }
}

export default NikoPatientTemplateList;